<template>
  <div id='bd-message'>
    <!-- TODO: 仅能向下加载更多，增加上拉加载更多 -->
    <!-- TODO: 识别文本中URL，可直接点击打开新网页 -->
    <el-empty v-if="monitorMessages.length === 0" description="暂无消息"></el-empty>
    <ul v-if="!disabled" class="bd-message-ul" ref="list" v-infinite-scroll="loadMoreMessage" infinite-scroll-disabled="loadDisabled">
      <!-- <div v-if="userCurrentMonitorThread.id !== 0 && !userCurrentMonitorThread.last" class="pullrefresh" @click="getMessages(20)">更多聊天记录</div> -->
      <!-- <li v-for="message in messages" :key="message.mid"> -->
      <li v-for="message in monitorMessages" :key="message.mid">

        <p class="timestamp">
          <span>{{ message.createdAt | datetime }}</span><br/>
          <span v-if="is_type_notification(message)">{{ message.content }}</span>
        </p>

        <div v-if="!is_type_notification(message)" class="main" :class="{ self: is_self(message) }">
          <img v-if="show_header" class="avatar" width="30" height="30"
            :src="message.user.avatar"
            @click="imageClicked(message.user.avatar)"/>
          <!-- <el-avatar v-if="show_header" class="avatar" size="medium"
              :src="message.user.avatar"
              @click="imageClicked(message.user.avatar)">
            </el-avatar> -->
          <div v-if="!is_self(message)" class="nickname">{{ message.user.nickname }}</div>
          <!-- TODO: 点击消息内容，弹窗用户选择：复制消息内容 or 撤回消息(3分钟之内) -->
          <div v-if="is_type_text(message)" class="text" v-html="replaceFace(message.content)"
            @click="textClicked(message)"
            @click.right="rightEvent(message)"
            @contextmenu.prevent="onContextmenu"></div>
          <!-- 暂不显示机器人消息 -->
          <div v-if="is_type_robot(message)" class="text" v-html="replaceFace(message.content)"></div>
          <div v-if="is_type_questionnaire(message)" class="text">
            <span>{{ message.questionnaire.questionnaireItems[0].title }}</span>
            <span v-for="item in message.questionnaire.questionnaireItems[0].questionnaireItemItems" :key="item.id">
              <br/>
              <span style="color:#007bff; cursor: pointer;">{{ item.content }}</span>
            </span>
          </div>
          <div v-if="is_type_company(message)" class="text">
            <span>{{ message.content }}</span>
            <span v-for="item in message.company.countries" :key="item.cid">
              <br/>
              <span style="color:#007bff; cursor: pointer;">{{ item.name }}</span>
            </span>
          </div>
          <div v-if="is_type_workGroup(message)" class="text">
            <span>{{ message.content }}</span>
            <span v-for="item in message.workGroups" :key="item.wid">
              <br/>
              <span style="color:#007bff; cursor: pointer;">{{ item.nickname }}</span>
            </span>
          </div>
          <div v-if="is_type_image(message)" class="text" @click.right="rightEvent(message)" @contextmenu.prevent="onContextmenu">
            <!-- <img :src="message.imageUrl" alt="[图片]"
              style="padding-top: 10px; padding-bottom: 10px; width: 100px; height: 100px;"
              @click="imageClicked(message.imageUrl)"/> -->
            <!-- FIXME: 预览时，非默认展示当前图片 :preview-src-list="previewImageSrcList" -->
            <el-image style="padding-top: 10px; width: 100px; height: 100px;"
              :src="message.imageUrl"
              :preview-src-list="[message.imageUrl]" lazy/>
          </div>
          <div v-if="is_type_file(message)" class="text" @click.right="rightEvent(message)" @contextmenu.prevent="onContextmenu">
            <img src="https://cdn.bytedesk.com/img/input/file.png" alt="[文件]"
              style="padding-top: 10px; padding-bottom: 10px; width: 25px; height: 25px;"
              @click="fileClicked(message.fileUrl)"/>
            <span><a :href="message.fileUrl" target="_blank">查看文件</a></span>
          </div>
          <div v-if="is_type_voice(message)" class="text" @click.right="rightEvent(message)" @contextmenu.prevent="onContextmenu">
            <img src="https://cdn.bytedesk.com/img/input/voice_received.png" alt="[语音]"
              style="padding-top: 10px; padding-bottom: 10px; width: 25px; height: 20px;"
              @click="voiceClicked(message.voiceUrl)"/>
          </div>
          <div v-if="is_type_video(message)" class="text" @click.right="rightEvent(message)" @contextmenu.prevent="onContextmenu">
            <span><a :href="message.videoOrShortUrl" target="_blank">{{ $t('viewVideo') }}</a></span>
          </div>

          <!-- TODO: 以下类型有待格式化显示 -->
          <div v-if="is_type_location(message)" class="text">{{ message.label }}</div>
          <div v-if="is_type_link(message)" class="text">{{ message.title }}</div>
          <div v-if="is_type_event(message)" class="text">{{ message.content }}</div>
          <div v-if="is_type_custom(message)" class="text">{{ message.content }}</div>
          <div v-if="is_type_red_packet(message)" class="text">{{ message.content }}</div>
          <div v-if="is_type_commodity(message)" class="text">
            <!-- <div>{{ message.content}}</div> -->
            <div>id: {{ jsonObject(message.content).id }}</div>
            <div>categoryCode: {{ jsonObject(message.content).categoryCode }}</div>
            <div>价格: {{ jsonObject(message.content).price }}</div>
            <div>标题: {{ jsonObject(message.content).title }}</div>
            <div><a style="color:blue;" :href="jsonObject(message.content).url" target="_blank">链接</a></div>
            <div>
              <a style="color:blue;" :href="jsonObject(message.content).url" target="_blank">
                <img :src="jsonObject(message.content).imageUrl" style="width: 50px; height:50px;"/>
              </a>
            </div>
          </div>

          <div v-if="is_self(message)" class="status" >
              <i v-if="is_sending(message)" class="el-icon-loading" style="font-size:10px"></i>
              <i v-if="is_stored(message)" class="fa fa-times-circle" style="font-size:10px"></i>
              <i v-if="is_received(message)" style="font-size:10px; margin-right: 5px;">送达</i>
              <i v-if="is_read(message)" style="font-size:10px; margin-right: 5px;">已读</i>
              <i v-if="is_error(message)" class="iconfont icon-error" style="font-size:10px"></i>
              <i v-if="can_recall(message)" class="el-icon-delete" @click="recallButtonClicked(message)"></i>
          </div>

        </div>
      </li>
    </ul>
    <!-- <p v-if="loadingMoreMessage">加载中...</p>
    <p v-if="noMoreMessage">没有更多了</p> -->

    <el-dialog title="查看大图" :modal="false" :visible.sync="imageDialogVisible" width="40%" :before-close="handleImageDialogClose">
      <span><img id="currentImage" :src="currentImageUrl" alt="[查看大图]" style="width: 100%; height: 100%;"/></span>
      <span slot="footer" class="dialog-footer">
        <!-- TODO: 增加复制网址、旋转、下载图片 -->
        <!-- <el-button v-if="electron && showAuthority.debug" @click="downloadImage">下载</el-button> -->
        <!-- <el-button @click="transformLarger">放大</el-button> -->
        <!-- <el-button @click="transformSmaller">缩小</el-button> -->
        <!-- <el-button @click="transformLeft">左旋转</el-button> -->
        <!-- <el-button @click="transformRight">右旋转</el-button> -->
        <el-button type="primary" @click="imageDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog v-dialogDrag
      title="提示"
      :visible.sync="recallDialogVisible"
      width="30%"
      center>
      <span>确定要撤回信息:{{ recallMessage.content }}?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="recallDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="doRecallMessage">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="语音播放器" :modal="false" width="30%" :visible.sync="dialogTableVisible" center>
      <!-- http://wuxieyun.com/opencore-amr-js/js/index.php?url=http://kefudashi.oss-cn-hangzhou.aliyuncs.com/voice/NkChHr9aE832V7iGtPBj37RmtPhzloHGopn8bE0gJsccf-zjj4bJlFBCv_qnszmr.amr -->
      <iframe :src="player_url"></iframe>
    </el-dialog>

  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import * as constants from '@/util/constants'
import bus from '@/util/eventbus'

export default {
  name: 'bd-message',
  data () {
    return {
      imageDialogVisible: false,
      recallMessage: {
        mid: '',
        content: ''
      },
      recallDialogVisible: false,
      currentImageUrl: '',
      currentVoiceUrl: '',
      dialogTableVisible: false,
      emojiBaseUrl: constants.EMOJI_BASE_URL,
      electron: constants.IS_ELECTRON,
      transformDegree: 0,
      visible: false,
      //
      count: 10,
      loadingMoreMessage: false
    }
  },
  computed: {
    // 'messages',
    ...mapGetters([ 'userInfo', 'userCurrentMonitorThread', 'userCurrentContact',
      'userCurrentGroup', 'monitorMessages', 'showAuthority' ]),
    ...mapState([
      'emotionMap', 'emotionWxMap'
    ]),
    disabled () {
      return this.userCurrentMonitorThread.id === 0
    },
    show_header () {
      return true
    },
    noMoreMessage () {
      return this.count >= 20
    },
    loadDisabled () {
      return this.loadingMoreMessage || this.noMoreMessage
    },
    previewImageSrcList () {
      let previewImageSrcList = []
      for (let i = 0; i < this.monitorMessages.length; i++) {
        const element = this.monitorMessages[i]
        if (element.type === constants.MESSAGE_TYPE_IMAGE) {
          previewImageSrcList.push(element.imageUrl)
        }
      }
      return previewImageSrcList
    }
  },
  methods: {
    ...mapActions([ 'getMessages' ]),
    ...mapActions('stomp', [ 'sendRecallMessage' ]),
    jsonObject (content) {
      return content === null ? '{"categoryCode":"","content":"","id":,"imageUrl":"","price":"","title":"","type":"commodity","url":""}' : JSON.parse(content)
    },
    textClicked (message) {
      let content = message.content.replaceAll('amp;', '')
      this.copyToClip(content);
      this.$message('"' + content + '" ' + this.$t("copiedToClip"));
      // 3分钟之内允许撤回
      // if (this.can_recall(message)) {
      //   this.recallMessage = message
      //   this.recallDialogVisible = true
      // }
    },
    recallButtonClicked (message) {
      console.log('text clicked:', message.mid, message.content)
      // 3分钟之内允许撤回
      if (this.can_recall(message)) {
        this.recallMessage = message
        this.recallDialogVisible = true
      }
    },
    imageClicked (imageUrl) {
      // console.log('image clicked:', imageUrl)
      this.currentImageUrl = imageUrl
      this.imageDialogVisible = true
    },
    fileClicked (fileUrl) {
      if (this.electron) {
        ipcRenderer.send('open-external-url', fileUrl)
      } else {
        window.open(fileUrl)
      }
    },
    voiceClicked (voiceUrl) {
      // console.log('voice clicked:', voiceUrl)
      this.currentVoiceUrl = voiceUrl
      // this.dialogTableVisible = true
      window.open(voiceUrl)
    },
    transformLarger () {
      console.log('transformLarger')
      let currentImage = document.getElementById('currentImage')
      currentImage.width = currentImage.width * 1.1
      currentImage.height = currentImage.height * 1.1
    },
    transformSmaller () {
      console.log('transformSmaller')
      let currentImage = document.getElementById('currentImage')
      currentImage.width = currentImage.width * 0.9
      currentImage.height = currentImage.height * 0.9
    },
    transformLeft () {
      this.transformDegree -= 90
      document.getElementById('currentImage').style.transform = 'rotate(' + this.transformDegree + 'deg)'
    },
    transformRight () {
      this.transformDegree += 90
      document.getElementById('currentImage').style.transform = 'rotate(' + this.transformDegree + 'deg)'
    },
    downloadImage () {
      console.log('downloadImage:', this.currentImageUrl)
      ipcRenderer.send('save-image-dialog', this.currentImageUrl)
    },
    is_self (message) {
      // return !message.user.visitor
      return message.client === constants.CLIENT_SYSTEM || message.user.uid === this.userInfo.uid
    },
    // 发送状态
    is_sending (message) {
      return message.status === constants.MESSAGE_STATUS_SENDING
    },
    is_stored (message) {
      return message.status === constants.MESSAGE_STATUS_STORED
    },
    is_received (message) {
      return message.status === constants.MESSAGE_STATUS_RECEIVED
    },
    is_error (message) {
      return message.status === constants.MESSAGE_STATUS_ERROR
    },
    is_read (message) {
      return message.status === constants.MESSAGE_STATUS_READ
    },
    can_recall (message) {
      return this.callRecallMessage(message) &&
        this.is_self(message) &&
        (message.type === constants.MESSAGE_TYPE_TEXT || message.type === constants.MESSAGE_TYPE_IMAGE)
    },
    // 消息类型
    is_type_text (message) {
      return message.type === constants.MESSAGE_TYPE_TEXT ||
      message.type === constants.MESSAGE_TYPE_NOTIFICATION_THREAD
    },
    is_type_robot (message) {
      // 大学长隐藏 机器人消息
      return message.type === constants.MESSAGE_TYPE_ROBOT
    },
    is_type_image (message) {
      return message.type === constants.MESSAGE_TYPE_IMAGE
    },
    is_type_file (message) {
      return message.type === constants.MESSAGE_TYPE_FILE
    },
    is_type_voice (message) {
      return message.type === constants.MESSAGE_TYPE_VOICE
    },
    is_type_video (message) {
      return message.type === constants.MESSAGE_TYPE_VIDEO || message.type === constants.MESSAGE_TYPE_SHORT_VIDEO
    },
    // is_type_shortvideo (message) {
    //   return message.type === constants.MESSAGE_TYPE_SHORT_VIDEO
    // },
    is_type_location (message) {
      return message.type === constants.MESSAGE_TYPE_LOCATION
    },
    is_type_link (message) {
      return message.type === constants.MESSAGE_TYPE_LINK
    },
    is_type_event (message) {
      return message.type === constants.MESSAGE_TYPE_EVENT
    },
    is_type_custom (message) {
      return message.type === constants.MESSAGE_TYPE_CUSTOM
    },
    is_type_red_packet (message) {
      return message.type === constants.MESSAGE_TYPE_RED_PACKET
    },
    is_type_commodity (message) {
      return message.type === constants.MESSAGE_TYPE_COMMODITY
    },
    is_type_questionnaire (message) {
      return message.type === constants.MESSAGE_TYPE_QUESTIONNAIRE
    },
    is_type_company (message) {
      return message.type === constants.MESSAGE_TYPE_COMPANY
    },
    is_type_workGroup (message) {
      return message.type === constants.MESSAGE_TYPE_WORK_GROUP
    },
    is_type_notification (message) {
      return message.type !== constants.MESSAGE_TYPE_NOTIFICATION_THREAD &&
      message.type.startsWith(constants.MESSAGE_TYPE_NOTIFICATION)
    },
    player_url () {
      return constants.VOICE_PLAYER_BASE_URL + this.currentVoiceUrl
    },
    //  在发送信息之后，将输入的内容中属于表情的部分替换成emoji图片标签
    //  再经过v-html 渲染成真正的图片
    // TODO: 解析微信表情
    replaceFace (content) {
      if (content == null || content === undefined) {
        return content
      }
      var wxConttent = this.replaceWeChatFace(content)
      var emotionMap = this.emotionMap
      var reg = /\[[\u4E00-\u9FA5NoOK]+\]/g
      var matchresult = wxConttent.match(reg)
      var result = wxConttent
      if (matchresult) {
        for (var i = 0; i < matchresult.length; i++) {
          result = result.replace(matchresult[i], '<img height=\'25px\' width=\'25px\' style=\'margin-bottom:4px;\' src=\'' + this.emojiBaseUrl + emotionMap[matchresult[i]] + '\'>')
        }
      }
      return result
    },
    replaceWeChatFace (content) {
      if (content == null || content === undefined) {
        return content
      }
      // setPattern("/::\\)|/::~|/::B|/::\\||/:8-\\)|/::<|/::\\$|/::X|/::Z|/::'\\(|/::-\\||/::@|/::P|/::D|/::O|/::\\(|/::\\+|/:--b|/::Q|/::T|/:,@P|/:,@-D|/::d|/:,@o|/::g|/:\\|-\\)|/::!|/::L|/::>|/::,@|/:,@f|/::-S|/:\\?|/:,@x|/:,@@|/::8|/:,@!|/:!!!|/:xx|/:bye|/:wipe|/:dig|/:handclap|/:&-\\(|/:B-\\)|/:<@|/:@>|/::-O|/:>-\\||/:P-\\(|/::'\\||/:X-\\)|/::\\*|/:@x|/:8\\*|/:pd|/:<W>|/:beer|/:basketb|/:oo|/:coffee|/:eat|/:pig|/:rose|/:fade|/:showlove|/:heart|/:break|/:cake|/:li|/:bome|/:kn|/:footb|/:ladybug|/:shit|/:moon|/:sun|/:gift|/:hug|/:strong|/:weak|/:share|/:v|/:@\\)|/:jj|/:@@|/:bad|/:lvu|/:no|/:ok|/:love|/:<L>|/:jump|/:shake|/:<O>|/:circle|/:kotow|/:turn|/:skip|/:oY|/:#-0|/:hiphot|/:kiss|/:<&|/:&>");
      var emotionMap = this.emotionWxMap
      var reg = /\/::\)|\/::~|\/::B|\/::\||\/:8-\)|\/::<|\/::\$|\/::X|\/::Z|\/::'\\(|\/::-\||\/::@|\/::P|\/::D|\/::O|\/::\\(|\/::\+|\/:--b|\/::Q|\/::T|\/:,@P|\/:,@-D|\/::d|\/:,@o|\/::g|\/:\\|-\\)|\/::!|\/::L|\/::>|\/::,@|\/:,@f|\/::-S|\/:\\?|\/:,@x|\/:,@@|\/::8|\/:,@!|\/:!!!|\/:xx|\/:bye|\/:wipe|\/:dig|\/:handclap|\/:&-\\(|\/:B-\\)|\/:<@|\/:@>|\/::-O|\/:>-\\||\/:P-\\(|\/::'\\||\/:X-\\)|\/::\\*|\/:@x|\/:8\\*|\/:pd|\/:<W>|\/:beer|\/:basketb|\/:oo|\/:coffee|\/:eat|\/:pig|\/:rose|\/:fade|\/:showlove|\/:heart|\/:break|\/:cake|\/:li|\/:bome|\/:kn|\/:footb|\/:ladybug|\/:shit|\/:moon|\/:sun|\/:gift|\/:hug|\/:strong|\/:weak|\/:share|\/:v|\/:@\\)|\/:jj|\/:@@|\/:bad|\/:lvu|\/:no|\/:ok|\/:love|\/:<L>|\/:jump|\/:shake|\/:<O>|\/:circle|\/:kotow|\/:turn|\/:skip|\/:oY|\/:#-0|\/:hiphot|\/:kiss|\/:<&|\/:&>/g
      var matchresult = content.match(reg)
      var result = content
      if (matchresult) {
        for (var i = 0; i < matchresult.length; i++) {
          result = result.replace(matchresult[i], '<img height=\'25px\' width=\'25px\' style=\'margin-bottom:4px;\' src=\'' + this.emojiBaseUrl + emotionMap[matchresult[i]] + '\'>')
        }
      }
      return result
    },
    handleImageDialogClose (done) {
      done()
    },
    scrollToBottom () {
      // 聊天记录滚动到最底部
      let vm = this
      this.$nextTick(() => {
        const ul = vm.$refs.list
        if (ul != null) {
          ul.scrollTop = ul.scrollHeight
        }
      })
    },
    // 撤回消息
    doRecallMessage () {
      this.recallDialogVisible = false
      // console.log(this.recallMessage.mid, this.recallMessage.content)
      //
      let payload = { mid: this.recallMessage.mid }
      this.sendRecallMessage(payload)
    },
    // 检测是否在3分钟之内，允许撤回消息
    callRecallMessage (message) {
      let now = moment(new Date(), 'YYYY-MM-DD HH:mm:ss')
      let createdAt = moment(message.createdAt, 'YYYY-MM-DD HH:mm:ss')
      let seconds = now.diff(createdAt, 'seconds')
      // 现在距消息发送的时间差
      // console.log('seconds passed: ', seconds)
      if (seconds < 180) {
        return true
      }
      return false
    },
    // 鼠标右键
    rightEvent (message) {
      // console.log('点击右键', message)
      this.rightClickMessage = message
    },
    // 引用第三方组件: https://github.com/GitHub-Laziji/menujs
    onContextmenu (event) {
      this.$contextmenu({
        items: [
          {
            label: this.$t('copy'),
            icon: 'el-icon-copy-document',
            onClick: () => {
              if (this.is_type_text(this.rightClickMessage)) {
                this.copyToClip(this.rightClickMessage.content)
                this.$message('"' + this.rightClickMessage.content + '" ' + this.$t('copiedToClip'));
              } else if (this.is_type_image(this.rightClickMessage)) {
                this.copyToClip(this.rightClickMessage.imageUrl)
                this.$message('"' + this.rightClickMessage.imageUrl + '" ' + this.$t('copiedToClip'));
              } else if (this.is_type_file(this.rightClickMessage)) {
                this.copyToClip(this.rightClickMessage.fileUrl)
                this.$message('"' + this.rightClickMessage.fileUrl + '" ' + this.$t('copiedToClip'));
              } else if (this.is_type_voice(this.rightClickMessage)) {
                this.copyToClip(this.rightClickMessage.voiceUrl)
                this.$message('"' + this.rightClickMessage.voiceUrl + '" ' + this.$t('copiedToClip'));
              } else if (this.is_type_video(this.rightClickMessage)) {
                this.copyToClip(this.rightClickMessage.videoOrShortUrl)
                this.$message('"' + this.rightClickMessage.videoOrShortUrl + '" ' + this.$t('copiedToClip'));
              }
            }
          }
        ],
        event,
        customClass: 'class-a',
        zIndex: 3,
        minWidth: 230
      })
      return false
    },
    copyToClip(content) {
      var aux = document.createElement("input"); 
      aux.setAttribute("value", content); 
      document.body.appendChild(aux); 
      aux.select();
      document.execCommand("copy"); 
      document.body.removeChild(aux);
    },
    // 加载更多
    loadMoreMessage () {
      console.log('loadMoreMessage')
      //
      this.loadingMoreMessage = true
      setTimeout(() => {
        this.count += 2
        this.loadingMoreMessage = false
      }, 100)
    }
  },
  mounted () {
    // 通知界面滚动到底部
    bus.$on(constants.EVENT_BUS_MESSAGE_SCROLL_TO_BOTTOM, () => {
      // console.log('scroll to bottom')
      let vm = this
      vm.$nextTick(() => {
        const ul = vm.$refs.list
        if (ul != null) {
          ul.scrollTop = ul.scrollHeight
        }
      })
    })
  },
  filters: {
    datetime (value) {
      if (typeof value === 'string') {
        return moment(value).format('YYYY-MM-DD HH:mm:ss')
      } else {
        return value
      }
    }
  }
}
</script>

<style scoped>
.pullrefresh {
  margin-top: 20px;
  text-align: center;
  font-size: 10px;
  color: blue;
  cursor: pointer;
}
#bd-message {
  /* width: calc(100% - 20px); */
  /* height: calc(100% - 200px); */
  width: 100%;
  height: 100%;
  margin-left: 5px;
  margin-right: 5px;
  /* padding-left: 10px; */
  /* padding-bottom: 20px; */
  overflow-y: scroll;
}
.bd-message-ul {
  /* border: 1px solid #ccf; */
  font-size: 16px;
  height: 100%;
  /* margin: 0; */
  margin-left: 0px;
  margin-top: 0px;
  /* margin-bottom: 10px; */
  /* padding-bottom: 10px; */
  overflow-y: auto;
  padding: 0;
}
li {
  margin-bottom: 15px;
  clear: both;
}
.main {
  margin-left: 0px;
}
.timestamp {
  margin: 10px 0;
  text-align: center;
  font-size: 10px;
}
.timestamp span {
  display: inline-block;
  padding: 0 8px;
  /* color: #fff; */
  border-radius: 5px;
  color: #bbbbbb;
}
.avatar {
  float: left;
  margin: 0 10px 0 0;
  border-radius: 3px;
}
.nickname {
  text-align: left;
  font-size: 10px;
}
.text {
  float: left;
  position: relative;
  padding: 2px 10px 0px;
  max-width: calc(100% - 250px);
  min-height: 30px;
  line-height: 2.5;
  font-size: 12px;
  text-align: left;
  word-break: break-all;
  background-color: #dddddd;
  border-radius: 4px;
}
.text:before {
  content: " ";
  position: absolute;
  top: 9px;
  right: 100%;
  border: 6px solid transparent;
  border-right-color: #dddddd;
}
.self {
  text-align: right;
}
.self .avatar {
  float: right;
  margin: 0 0 0 10px;
}
.self .nickname {
  text-align: right;
  font-size: 10px;
}
.self .text {
  float: right;
  background-color: #b2e281;
}
.self .text:before {
  right: inherit;
  left: 100%;
  border-right-color: transparent;
  border-left-color: #b2e281;
}
.self .status {
  float: right;
  margin-right: 8px;
}
.notification {
  text-align: center;
}
.chat li {
  border: none;
}
</style>
